import { BidderOffOverlayComponent } from "@m19-board/overlay/overlays/bidder-off/bidder-off-overlay.component";
import { BidderOffWhitelabelOverlayComponent } from "@m19-board/overlay/overlays/bidder-off/bidder-off-whitelabel-overlay.component";
import { AdvertisingApiAccessLostOverlayComponent } from "@m19-board/overlay/overlays/advertising-api-access-lost-overlay.component";
import { ManualActivationRequiredOverlayComponent } from "@m19-board/overlay/overlays/manual-activation-required-overlay.component";
import { InvalidSellingPartnerApiAccessOverlayComponent } from "@m19-board/overlay/overlays/invalid-selling-partner-api-access-overlay.component";
import { OverlayComponent } from "@m19-board/overlay/overlay-service/overlay-rules";
import { MarketplaceNotIncludedOverlayComponent } from "@m19-board/overlay/overlays/marketplace-not-included-overlay.component";
import { StartFreeTestOverlayComponent } from "@m19-board/overlay/overlays/start-free-test-overlay.component";
import { OnboardingCallScheduledOverlayComponent } from "@m19-board/overlay/overlays/onboarding-call-scheduled-overlay.component";
import { OnboardingCallOverlayComponent } from "@m19-board/overlay/overlays/onboarding-call-overlay.component";

interface AccountStatusOverlays {
  bidderOff?: OverlayComponent;
  startFreeTest?: OverlayComponent;
}

export function accountStatusOverlays(bidderOff?: AccountStatusOverlays): OverlayComponent[] {
  return [
    bidderOff?.startFreeTest ?? StartFreeTestOverlayComponent,
    OnboardingCallOverlayComponent,
    OnboardingCallScheduledOverlayComponent,
    BidderOffWhitelabelOverlayComponent,
    bidderOff?.bidderOff ?? BidderOffOverlayComponent,
    ManualActivationRequiredOverlayComponent,
    MarketplaceNotIncludedOverlayComponent,
  ];
}

export function apiAccessOverlays(): OverlayComponent[] {
  return [AdvertisingApiAccessLostOverlayComponent, InvalidSellingPartnerApiAccessOverlayComponent];
}

export function dspAccessOverlays(): OverlayComponent[] {
  return [AdvertisingApiAccessLostOverlayComponent];
}
